import { Schema } from "effect";
import { utf8ByteLength } from "./utf8";

export const INTERNAL_POLAR_EVENT_MAX_BYTES = 256 * 1_024;

export const InternalPolarEventSchema = Schema.Struct({
  eventId: Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(180)),
  eventType: Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(120)),
  workspaceId: Schema.optionalKey(
    Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(180)),
  ),
  payload: Schema.String.check(
    Schema.isMinLength(1),
    Schema.makeFilter(
      (value) =>
        utf8ByteLength(value) <= INTERNAL_POLAR_EVENT_MAX_BYTES ||
        `must be at most ${INTERNAL_POLAR_EVENT_MAX_BYTES} UTF-8 bytes`,
    ),
  ),
});

export const decodeInternalPolarEvent = Schema.decodeUnknownSync(InternalPolarEventSchema, {
  errors: "all",
  onExcessProperty: "error",
  reportInput: false,
});

export type InternalPolarEvent = typeof InternalPolarEventSchema.Type;
